import React from "react";

const n = (v) => Number(v || 0).toLocaleString();
const pct = (v, total) => (total ? `${((v / total) * 100).toFixed(0)}%` : "0%");

function GaTable({ title, cols, rows, testId, empty = "No data in this period yet." }) {
  return (
    <section className="brut-card overflow-x-auto" data-testid={testId}>
      <div className="border-b-2 border-black px-3 py-2 font-chivo font-black">{title}</div>
      <table className="w-full text-sm">
        <thead className="bg-zinc-100 text-left text-[10px] uppercase tracking-widest">
          <tr>{cols.map(([label, , right]) => <th key={label} className={`px-3 py-2 ${right ? "text-right" : ""}`}>{label}</th>)}</tr>
        </thead>
        <tbody>
          {!rows.length && <tr><td colSpan={cols.length} className="label-mono px-3 py-5 text-center">{empty}</td></tr>}
          {rows.map((r, i) => (
            <tr key={i} className="border-t border-zinc-200" data-testid={`${testId}-row-${i}`}>
              {cols.map(([label, get, right]) => <td key={label} className={`px-3 py-1.5 ${right ? "text-right font-mono" : "break-all"}`}>{get(r)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}

export function GaTables({ data }) {
  const totalVisitors = data.devices.reduce((s, d) => s + d.visitors, 0);
  return (
    <div className="grid gap-4 lg:grid-cols-2">
      <GaTable title="Top landing pages" testId="ga-landing" rows={data.landing_pages}
               cols={[["Page", (r) => r.page], ["Sessions", (r) => n(r.sessions), true], ["Visitors", (r) => n(r.visitors), true], ["Thank-you", (r) => n(r.thank_you_views), true]]} />
      <GaTable title="Traffic sources" testId="ga-sources" rows={data.sources}
               cols={[["Source / medium", (r) => `${r.source} / ${r.medium}`], ["Sessions", (r) => n(r.sessions), true], ["Thank-you", (r) => n(r.thank_you_views), true]]} />
      <GaTable title="Visitors by state" testId="ga-states" rows={data.states}
               cols={[["State", (r) => r.state], ["Visitors", (r) => n(r.visitors), true], ["Sessions", (r) => n(r.sessions), true]]} />
      <GaTable title="Visitors by device" testId="ga-devices" rows={data.devices}
               cols={[["Device", (r) => r.device], ["Visitors", (r) => n(r.visitors), true], ["Share", (r) => pct(r.visitors, totalVisitors), true]]} />
    </div>
  );
}
